import "@fontsource-variable/inter";
import "./styles/theme.css";
import "./styles/app.css";
import "./styles/editor.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { isNative } from "./api";
import { onOldAddress } from "./moved";
import { applyTheme, usePrefs } from "./ui/prefs";
import { startWebUpdates } from "./updater";

// Re-applied only when the mode, palette or system dark setting changes (not on every pref, e.g. a sidebar toggle:
// applying a palette restyles the whole page).
let applied = "";
const theme = () => {
  const { theme: mode, palette } = usePrefs.getState();
  const key = `${mode}|${palette}|${matchMedia("(prefers-color-scheme: dark)").matches}`;
  if (key === applied) return;
  applied = key;
  applyTheme(mode, palette);
};
theme();
usePrefs.subscribe(theme);
matchMedia("(prefers-color-scheme: dark)").addEventListener("change", theme);

// Offline startup for the web app (the Android app ships its files in the APK).
if (import.meta.env.PROD && "serviceWorker" in navigator && !isNative) {
  // Not on the old address, which this browser is about to leave (moved.ts); one installed there still updates.
  if (!onOldAddress) void navigator.serviceWorker.register("/sw.js");
  startWebUpdates(); // and a new version reaches an open tab (updater.ts)
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
